module.exports = __webpack_public_path__ + "img/logo-flat-dark.e0eaaf38.svg";